import { lazy } from 'react';

export const AnalyzerPageLazy = lazy(() => import('./AnalyzerPage'));
